import { RomaniaMaxPriceGroupItemStatusSerializable } from 'com.cogvio.pricemonitor.api';
import mapGeneralProduct, { RawProduct as RawGeneralProduct } from '~/Api/Product/mapProduct';
import { mapReferencePrice, RawReferencePrice } from '~/Api/User/ProductGroup/RoMaxPrice/mapReferencePrice';
import { Product } from '~/Api/User/ProductGroup/RoMaxPrice/Product';

export interface RawProduct {
	packageSizeForCalculation: number | null;
	packageSizeForSingleUnit: number | null;
	product: RawGeneralProduct;
	referenceDataSource: boolean;
	referencePrices: RawReferencePrice[];
	selectable: boolean;
	selected: boolean;
	singleUnitPackageSize: boolean;
	groupItemStatus: RomaniaMaxPriceGroupItemStatusSerializable;
}

export const mapProduct = (product: RawProduct): Product => {
	return new Product(
		product.packageSizeForCalculation,
		product.packageSizeForSingleUnit,
		mapGeneralProduct(product.product),
		product.referenceDataSource,
		product.referencePrices.map(mapReferencePrice),
		product.selectable,
		product.selected,
		product.singleUnitPackageSize,
		product.groupItemStatus
	);
};
